import { render, staticRenderFns } from "./ShipTransfer.vue?vue&type=template&id=55b25674&scoped=true&"
import script from "./ShipTransfer.vue?vue&type=script&lang=js&"
export * from "./ShipTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b25674",
  null
  
)

export default component.exports